import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";

import GatsbyImageWithSVGSupport from "./GatsbyImageWithSVGSupport";
import RichTextBlock from "./RichTextBlock";
import BusinessInfoModalForm from "./BusinessInfoModalForm";

import { getCtaProps } from "../utils/utils";
import { openModal, selectModalId } from "../redux/slices/businessModalSlice";

import "../styles/components/CarouselCard.scss";

const CarouselCard = ({
    id,
    title,
    copy,
    media,
    ctaLink,
    pdf,
    isFreeToDownload,
    source,
}) => {
    const dispatch = useDispatch();
    const modalId = useSelector(selectModalId);

    let ctaLabel = "Read More";
    if (source === "ebook") {
        ctaLabel = "Download eBook";
    } else if (pdf) {
        ctaLabel = "Download PDF";
    }

    const btnProps = isFreeToDownload
        ? getCtaProps(ctaLink, pdf)
        : {
              onClick: () =>
                  dispatch(
                      openModal({
                          modalId: id,
                          download: !!pdf.url,
                          link: ctaLink || pdf.url,
                          contentDescription: pdf?.title,
                          source,
                      })
                  ),
          };

    return (
        <div className="carousel-card">
            <GatsbyImageWithSVGSupport className="image" image={media} />
            <div className=" d-flex flex-column px-4 mt-4">
                <h5>{title}</h5>
                {copy && <RichTextBlock content={copy} />}
            </div>
            <Button
                variant="link"
                className="d-flex mt-auto px-4 pb-4"
                {...btnProps}
            >
                {ctaLabel} &rarr;
            </Button>
            {id === modalId && <BusinessInfoModalForm />}
        </div>
    );
};

CarouselCard.propTypes = {
    title: PropTypes.string.isRequired,
    copy: PropTypes.shape({ raw: PropTypes.string.isRequired }),
    media: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        gatsbyImageData: PropTypes.object,
        file: PropTypes.shape({
            contentType: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        }),
    }),
    pdf: PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
    }),
    ctaLink: PropTypes.string,
    isFreeToDownload: PropTypes.bool,
    source: PropTypes.string.isRequired,
};

export default CarouselCard;
